import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

/** Route users based on their state:
 *  - No role yet → /onboarding
 *  - Admin (any) → /admin
 *  - Professional → /professional
 *  - Facility → /facility
 */
export default function Dashboard() {
  const { user, loading } = useAuth();
  if (loading || !user) return <div className="p-8 text-slate-500">Loading…</div>;
  if (!user.role) return <Navigate to="/onboarding" replace />;
  if (user.is_admin) return <Navigate to="/admin" replace />;
  if (user.role === "professional") return <Navigate to="/professional" replace />;
  return <Navigate to="/facility" replace />;
}
